import { memo } from 'react';

import { FiX } from 'react-icons/fi';

import * as S from './styles';

type GamificationToastProps = {
  heading: string;
  footnotes: string;
  visible: boolean;
  onClose: () => void;
  onPause?: () => void;
  onResume?: () => void;
};

const formatHeading = (heading: string) => {
  const match = heading.match(/(\d+)\s*pontos?/i);
  if (!match) return heading;

  const points = match[1];
  const parts = heading.split(match[0]);

  return (
    <>
      {parts[0]}
      <S.Highlight>+{points} pts</S.Highlight>
      {parts[1]}
    </>
  );
};

const GamificationToast = ({
  heading,
  footnotes,
  visible,
  onClose,
  onPause,
  onResume,
}: GamificationToastProps) => (
  <S.Overlay>
    <S.Container
      $visible={visible}
      onMouseEnter={onPause}
      onMouseLeave={onResume}
    >
      <S.Sparkle $top="8px" $right="60px" $delay="0.4s" />
      <S.Sparkle $top="16px" $right="100px" $delay="0.6s" $size="3px" />
      <S.Sparkle $bottom="14px" $right="50px" $delay="0.8s" $size="3px" />

      <S.Confetti>🎉</S.Confetti>

      <S.Body>
        <S.Text>{formatHeading(heading)}</S.Text>
        <S.Sub>{footnotes}</S.Sub>
      </S.Body>

      <S.CloseButton type="button" onClick={onClose}>
        <FiX size={10} strokeWidth={2.5} />
      </S.CloseButton>

      <S.CountdownBar />
    </S.Container>
  </S.Overlay>
);

export default memo(GamificationToast);
